import React, {useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {isEntitled, _openModal} from '../../../shared/store';
import {Button} from '../../../shared';
import history from '../../../history';

const HouseholdActivationButton = props => {
  const {openModal, disabled = false, household, width, importance = 'secondary'} = props;

  const [isActivated, setIsActivated] = useState(false);
  const entitled = isEntitled([{group: 'advisor', feature: 'household_activation_email', access: 'c'}]);
  let label = '';
  let action;

  const onSuccess = () => {
    setIsActivated(true);
  };

  if (entitled) {
    label = household.activatedAt ? 'Resend Email' : 'Activate';
    action = () => history.push(`/manage/households/${household.id}/activate`);
  } else {
    if (household.activatedAt || isActivated) return null;

    label = 'Activate';
    action = () => openModal({
      componentName: 'HouseholdActivationModal',
      household,
      onSuccess,
    });
  }

  const buttonProps = {
    disabled,
    size: 'sm',
    ...(width && {width}),
    importance,
    label,
    action,
  };

  return <Button {...buttonProps}/>;
};

const mapDispatchToProps = dispatch => ({
  openModal: modalToRemove => dispatch(_openModal(modalToRemove)),
});

export default connect(null, mapDispatchToProps)(HouseholdActivationButton);

HouseholdActivationButton.propTypes = {
  openModal: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.string,
  width: PropTypes.string,
  importance: PropTypes.oneOf(['secondary', 'primary']),
  household: PropTypes.shape({
    id: PropTypes.number,
    activatedAt: PropTypes.string,
    firmID: PropTypes.number,
    email: PropTypes.string,
    name: PropTypes.string,
    originalEmail: PropTypes.string,
    originalName: PropTypes.string,
  }),
};
